import React from "react";
import { Box, Typography, Button, Container, Stack } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    textAlign: "center",
                    py: 8,
                }}
            >
                <ErrorOutlineIcon color="error" sx={{ fontSize: 80 }} />

                <Typography variant="h3" component="h1" gutterBottom>
                    403 - Unauthorized
                </Typography>

                <Typography variant="body1" sx={{ mb: 4 }}>
                    You don’t have permission to access this page. Please contact to Admin
                </Typography>

                {/* <Stack spacing={2} direction="row" justifyContent="center">
                    
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/program-dashboard/program-dashboard")}
                    >
                        Go to Dashboard
                    </Button>
                </Stack> */}
            </Box>
        </Container>
    );
};

export default UnauthorizedPage;
